// Static job data — manually editable. No database, no API.
export const jobs = [
  {
    id: 1,
    title: "Software Developer",
    location: "United States",
    type: "Full Time",
    experience: "Entry Level",
    industry: "Technology",
    featured: true,
    summary:
      "Build and maintain scalable applications while collaborating with cross-functional teams to ship reliable, well-tested software.",
    responsibilities: [
      "Develop, test and deploy application features",
      "Collaborate with product and design teams",
      "Write clean, maintainable and documented code",
    ],
    skills: ["JavaScript", "React", "APIs", "Git"],
  },
  {
    id: 2,
    title: "Data Analyst",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Analytics",
    featured: true,
    summary:
      "Turn raw data into clear, actionable insight that guides business decisions across the organization.",
    responsibilities: [
      "Analyze datasets and identify trends",
      "Build dashboards and reporting workflows",
      "Communicate findings to stakeholders",
    ],
    skills: ["SQL", "Python", "Visualization", "Statistics"],
  },
  {
    id: 3,
    title: "Business Analyst",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Consulting",
    featured: true,
    summary:
      "Bridge business needs and technical solutions by mapping requirements and improving processes end-to-end.",
    responsibilities: [
      "Gather and document business requirements",
      "Map processes and recommend improvements",
      "Coordinate between business and delivery teams",
    ],
    skills: ["Requirements", "Process Mapping", "Stakeholder Management"],
  },
  {
    id: 4,
    title: "Cloud Engineer",
    location: "United States",
    type: "Full Time",
    experience: "Senior Level",
    industry: "Technology",
    featured: false,
    summary:
      "Design and operate resilient cloud infrastructure with a focus on automation, security and cost efficiency.",
    responsibilities: [
      "Architect and maintain cloud environments",
      "Automate deployments and monitoring",
      "Ensure security and reliability standards",
    ],
    skills: ["AWS", "Terraform", "CI/CD", "Kubernetes"],
  },
  {
    id: 5,
    title: "UX Designer",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Design",
    featured: false,
    summary:
      "Craft intuitive, accessible experiences grounded in research and validated through iteration.",
    responsibilities: [
      "Conduct research and usability testing",
      "Design flows, wireframes and prototypes",
      "Partner with engineering on implementation",
    ],
    skills: ["Figma", "Prototyping", "Research", "Design Systems"],
  },
  {
    id: 6,
    title: "Project Coordinator",
    location: "United States",
    type: "Full Time",
    experience: "Entry Level",
    industry: "Operations",
    featured: false,
    summary:
      "Keep initiatives on track by coordinating schedules, communication and deliverables across teams.",
    responsibilities: [
      "Coordinate timelines and deliverables",
      "Maintain documentation and status reports",
      "Support teams with day-to-day logistics",
    ],
    skills: ["Organization", "Communication", "Scheduling"],
  },
  {
    id: 7,
    title: "QA Engineer",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Technology",
    featured: false,
    summary:
      "Safeguard product quality through thoughtful test strategy, automation and clear defect reporting.",
    responsibilities: [
      "Design and execute test plans",
      "Build automated test coverage",
      "Report and track defects to resolution",
    ],
    skills: ["Automation", "Test Design", "Debugging"],
  },
  {
    id: 8,
    title: "Marketing Specialist",
    location: "United States",
    type: "Full Time",
    experience: "Entry Level",
    industry: "Marketing",
    featured: false,
    summary:
      "Drive brand growth through data-informed campaigns across digital and content channels.",
    responsibilities: [
      "Plan and run marketing campaigns",
      "Analyze performance and optimize",
      "Create content across channels",
    ],
    skills: ["Content", "Analytics", "SEO", "Social"],
  },
  {
    id: 9,
    title: "Customer Service Representative",
    location: "United States",
    type: "Full Time",
    experience: "Entry Level",
    industry: "Customer Service",
    featured: true,
    summary:
      "Support customers with professional communication, problem-solving and a strong commitment to exceptional service.",
    responsibilities: [
      "Assist customers through phone, email and digital channels",
      "Resolve customer questions and service issues",
      "Maintain accurate customer records and follow-up",
    ],
    skills: ["Communication", "Customer Support", "Problem Solving", "CRM"],
  },
  {
    id: 10,
    title: "Project Manager",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Project Management",
    featured: true,
    summary:
      "Lead projects from planning through delivery while coordinating teams, timelines, budgets and stakeholder expectations.",
    responsibilities: [
      "Plan and manage project timelines and deliverables",
      "Coordinate cross-functional teams and stakeholders",
      "Track project risks, budgets and overall progress",
    ],
    skills: ["Project Management", "Leadership", "Agile", "Stakeholder Management"],
  },
  {
    id: 11,
    title: "Scrum Master",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Project Management",
    featured: true,
    summary:
      "Facilitate Agile teams, remove delivery blockers and help organizations continuously improve their development process.",
    responsibilities: [
      "Facilitate Scrum ceremonies and team collaboration",
      "Remove impediments affecting delivery",
      "Support continuous improvement and Agile practices",
    ],
    skills: ["Scrum", "Agile", "Jira", "Team Facilitation"],
  },
  {
    id: 12,
    title: "Agile Project Manager",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Project Management",
    featured: false,
    summary:
      "Combine project leadership with Agile methodologies to drive adaptable planning, collaboration and successful delivery.",
    responsibilities: [
      "Lead Agile project planning and execution",
      "Coordinate cross-functional delivery teams",
      "Track priorities, risks and project outcomes",
    ],
    skills: ["Agile", "Scrum", "Project Management", "Jira"],
  },
  {
    id: 13,
    title: "Project Scheduler",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Project Management",
    featured: false,
    summary:
      "Maintain accurate project schedules while coordinating milestones, resources and deadlines across teams.",
    responsibilities: [
      "Develop and maintain project schedules",
      "Track milestones, dependencies and deadlines",
      "Coordinate schedule updates with project teams",
    ],
    skills: ["Scheduling", "MS Project", "Planning", "Excel"],
  },
  {
    id: 14,
    title: "Cybersecurity Engineer",
    location: "United States",
    type: "Full Time",
    experience: "Senior Level",
    industry: "Cybersecurity",
    featured: true,
    summary:
      "Protect enterprise systems and data by designing, implementing and maintaining robust cybersecurity solutions.",
    responsibilities: [
      "Monitor and strengthen security infrastructure",
      "Identify vulnerabilities and support remediation",
      "Implement security controls and best practices",
    ],
    skills: ["Cybersecurity", "SIEM", "Network Security", "Cloud Security"],
  },
  {
    id: 15,
    title: "Network Engineer",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Technology",
    featured: false,
    summary:
      "Design, configure and maintain reliable network infrastructure that supports secure and efficient business operations.",
    responsibilities: [
      "Configure and maintain network infrastructure",
      "Monitor network performance and troubleshoot issues",
      "Implement network security and connectivity solutions",
    ],
    skills: ["Networking", "TCP/IP", "Cisco", "Firewalls"],
  },
  {
    id: 16,
    title: "DevOps Engineer",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Technology",
    featured: true,
    summary:
      "Build reliable deployment pipelines and automation systems that help engineering teams ship software faster and more safely.",
    responsibilities: [
      "Build and maintain CI/CD pipelines",
      "Automate infrastructure and deployment workflows",
      "Monitor application and infrastructure performance",
    ],
    skills: ["AWS", "Docker", "Kubernetes", "CI/CD"],
  },
  {
    id: 17,
    title: "Fraud Risk Data Analyst",
    location: "United States",
    type: "Full Time",
    experience: "Mid Level",
    industry: "Analytics",
    featured: false,
    summary:
      "Analyze transaction and customer data to identify fraud patterns, assess risk and support data-driven fraud prevention strategies.",
    responsibilities: [
      "Analyze data to identify suspicious patterns and trends",
      "Develop reports and insights for fraud risk teams",
      "Support fraud detection and risk mitigation initiatives",
    ],
    skills: ["SQL", "Python", "Fraud Analytics", "Data Visualization"],
  },
];

export const LOCATIONS = ["All Locations", "United States"];

export const INDUSTRIES = [
  "All Industries",
  "Technology",
  "Analytics",
  "Consulting",
  "Design",
  "Operations",
  "Marketing",
  "Customer Service",
  "Project Management",
  "Cybersecurity",
];

export const EXPERIENCE_LEVELS = [
  "All Levels",
  "Entry Level",
  "Mid Level",
  "Senior Level",
];

export const JOB_TYPES = ["All Types", "Full Time", "Part Time", "Contract"];
